import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class TrimsDTO {
    @ApiProperty()
    @IsNotEmpty({message:"trimsid should not be empty"})
    
    @IsAlphanumeric()
    trimsId: number;

    @ApiProperty()
    @IsNotEmpty({message:"Trim should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    trimName: string;

   
    @ApiProperty()
    isActive: boolean;

    createdAt : Date;

   @ApiProperty()
   @IsOptional()
   @MaxLength(50,{message:"Created User allows maximum 50 characters"}) 
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })  
   createdUser :string ;

   updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(50, { message: "Updated User allows maximum 50 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;
  

  @ApiProperty()
  versionFlag : number;

}